<template>
  <v-container class="my-4">
    <v-card color="primary" class="fipa--header add-btn-wrap" />
    <v-data-table
      :headers="headers"
      :items="duplicateHorses"
      :hide-default-header="$vuetify.display.smAndDown ? true : false"
      class="entsys--table"
      disable-sort
      hide-default-footer
    >
      <template #item="{ item }">
        <td>{{ item.activeIdentifier }}</td>
        <td>
          <router-link
            :to="{ name: 'HorseProfilePage', params: { horseId: item.id } }"
          >
            <span class="uppercase">{{ item.name }}</span>
          </router-link>
        </td>
        <td>{{ item.birthName }}</td>
        <td>{{ item.dateOfBirth }}</td>
        <td>{{ item.ownerName }}</td>
        <td>{{ item.breederName }}</td>
        <td>{{ item.sireName }}</td>
        <td>{{ item.damName }}</td>
        <td>{{ item.damSireName }}</td>
        <td>{{ item.breedId ? item.breed.name : "" }}</td>
        <td class="text-right">
          <span v-if="duplicateRecordType(item) == 'primary_duplicate'"
            >Main horse record</span
          >
          <span v-if="duplicateRecordType(item) == 'secondary_duplicate'"
            >Secondary record</span
          >
          <v-btn-icon
            v-if="
              duplicateRecordType(item) == 'potential_duplicate' &&
              $allowedMutation(item.allowedMutations, 'horseConfirmDuplicate')
            "
            icon
            class="bg-edit-green"
            @click="confirmDuplicate(item, $event)"
          >
            <v-icon color="white"> $edit </v-icon>
            <v-progress-circular
              v-show="false"
              color="white"
              size="21"
              indeterminate
            />
          </v-btn-icon>
          <v-btn-icon
            v-if="
              duplicateRecordType(item) == 'potential_duplicate' &&
              $allowedMutation(item.allowedMutations, 'horseDeclineDuplicate')
            "
            icon
            class="bg-remove"
            @click="declineDuplicate(item, $event)"
          >
            <v-icon color="white"> $iconTrash </v-icon>
            <v-progress-circular
              v-show="false"
              color="white"
              size="21"
              indeterminate
            />
          </v-btn-icon>
        </td>
        <td v-if="$vuetify.display.smAndDown">TODO: mobile view</td>
      </template>
    </v-data-table>
  </v-container>
</template>
<script>
import gql from "fraql";
import { showLoadingButton } from "@/utils/showLoadingButton";

export default {
  name: "HorseDuplicatesSection",
  props: {
    horseId: {
      type: String,
      required: true
    },
    duplicateHorses: {
      type: Array,
      required: true
    }
  },
  emits: ["changed"],
  data() {
    return {
      headers: [
        { value: "activeIdentifier", title: "ID", sortable: false },
        { value: "name", title: "Name", sortable: true },
        { value: "birthName", title: "Birth name", sortable: true },
        { value: "dateOfBirth", title: "Birth date", sortable: true },
        { value: "ownerName", title: "Owner", sortable: true },
        { value: "breederName", title: "Breeder", sortable: true },
        { value: "sireName", title: "Sire", sortable: true },
        { value: "damName", title: "Dam", sortable: true },
        { value: "damSireName", title: "Dam sire", sortable: true },
        { value: "breedId", title: "Breed", sortable: true },
        { value: "", title: "", sortable: false }
      ]
    };
  },
  fragments: {
    horse: gql`
      fragment _ on Horse {
        id
        isDuplicateOfHorseId
        name
        birthName
        activeIdentifier
        dateOfBirth
        ownerName
        breederName
        sireName
        damName
        damSireName
        breedId
        breed @client {
          id
          name
        }
        duplicateHorses {
          id
        }
        allowedMutations
      }
    `
  },
  methods: {
    duplicateRecordType(horse) {
      if (horse.isDuplicateOfHorseId) {
        return "secondary_duplicate";
      } else if (horse.duplicateHorses.map(h => h.id).includes(this.horseId)) {
        return "primary_duplicate";
      } else {
        return "potential_duplicate";
      }
    },
    declineDuplicate(item, node) {
      this.$root
        .$confirm(
          "Delete",
          "Are you sure? Declining a duplicate means that it will not be considered duplicate for this horse again."
        )
        .then(async confirm => {
          if (confirm) {
            const removeLoading = showLoadingButton(node.target);
            this.$apollo
              .mutate({
                mutation: gql`
                  mutation horseDeclineDuplicate(
                    $horseId: ID!
                    $duplicateHorseId: ID!
                  ) {
                    horseDeclineDuplicate(
                      input: {
                        horseId: $horseId
                        duplicateHorseId: $duplicateHorseId
                      }
                    ) {
                      horse {
                        id
                      }
                    }
                  }
                `,
                variables: {
                  horseId: this.horseId,
                  duplicateHorseId: item.id
                }
              })
              .then(() => {
                // Result
                this.$root.$snackbar("success", {
                  text: "Succesfully declined!"
                });
                this.$emit("changed", true);
              })
              .catch(error => {
                // Error
                removeLoading();
                this.$root.$snackbar("error", { text: error });
                throw error;
              });
          }
        });
    },
    confirmDuplicate(item, node) {
      this.$root
        .$confirm(
          "Confirm",
          "Are you sure? Confirming a duplicate means that it will not be usable as a stand-alone horse record, but will be only preserved for archiving reasons and will be accessible via main horse record."
        )
        .then(async confirm => {
          if (confirm) {
            const removeLoading = showLoadingButton(node.target);
            this.$apollo
              .mutate({
                mutation: gql`
                  mutation horseConfirmDuplicate(
                    $horseId: ID!
                    $duplicateHorseId: ID!
                  ) {
                    horseConfirmDuplicate(
                      input: {
                        horseId: $horseId
                        duplicateHorseId: $duplicateHorseId
                      }
                    ) {
                      horse {
                        id
                      }
                    }
                  }
                `,
                variables: {
                  horseId: this.horseId,
                  duplicateHorseId: item.id
                }
              })
              .then(() => {
                // Result
                this.$root.$snackbar("success", {
                  text: "Succesfully confirmed!"
                });
                this.$emit("changed", true);
              })
              .catch(error => {
                // Error
                removeLoading();
                this.$root.$snackbar("error", { text: error });
                throw error;
              });
          }
        });
    }
  }
};
</script>
